import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["icon", "description", "elemAfter", "shouldAllowMultiline", "onClick", "children", "lozenges", "product", "createAnalyticsEvent"];
/** @jsx jsx */
/** @jsxFrag */
import React from 'react';
import { LinkItem } from '@atlaskit/menu';
import { RenderTracker, SWITCHER_ITEM_LOZENGES_SUBJECT } from '../../common/utils/analytics';
import { FadeIn } from './fade-in';
import { css, jsx } from '@emotion/react';
import Lozenge from '@atlaskit/lozenge';
import { FormattedMessage } from 'react-intl-next';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import messages from './messages';
import ErrorBoundary from '../components/error-boundary';
import * as colors from '@atlaskit/theme/colors';
export var LozengeType = /*#__PURE__*/function (LozengeType) {
  LozengeType["New"] = "new";
  return LozengeType;
}({});
var lozengeData = _defineProperty({}, LozengeType.New, {
  label: messages.newLozenge,
  componentProps: {
    appearance: 'new'
  }
});
var fadeInStyles = css({
  width: '100%'
});
var itemDescriptionStyles = css({
  color: "var(--ds-text-subtlest, ".concat(colors.N200, ")"),
  fontSize: 11,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
});
var SwitcherItem = function SwitcherItem(_ref) {
  var icon = _ref.icon,
    description = _ref.description,
    elemAfter = _ref.elemAfter,
    shouldAllowMultiline = _ref.shouldAllowMultiline,
    _onClick = _ref.onClick,
    children = _ref.children,
    lozenges = _ref.lozenges,
    product = _ref.product,
    createAnalyticsEvent = _ref.createAnalyticsEvent,
    rest = _objectWithoutProperties(_ref, _excluded);
  var itemDescription = React.useMemo(function () {
    if ( /*#__PURE__*/React.isValidElement(description) || typeof description === 'string') {
      return jsx("div", {
        css: itemDescriptionStyles
      }, description);
    }
    return undefined;
  }, [description]);
  var renderLozenges = React.useMemo(function () {
    if (!(lozenges !== null && lozenges !== void 0 && lozenges.length)) {
      return null;
    }
    return jsx(ErrorBoundary, {
      product: product,
      triggerSubject: "switcherItemLozengeErrorBoundary",
      hideFallbackUI: true
    }, jsx(React.Fragment, null, lozenges.map(function (lozenge) {
      var _lozengeData$lozenge = lozengeData[lozenge],
        componentProps = _lozengeData$lozenge.componentProps,
        label = _lozengeData$lozenge.label;
      return jsx("span", {
        style: {
          marginLeft: "var(--ds-space-100, 8px)"
        }
      }, jsx(Lozenge, _extends({}, componentProps, {
        "data-testid": "switcher-item-lozenge"
      }), jsx(FormattedMessage, label)));
    }), jsx(RenderTracker, {
      subject: SWITCHER_ITEM_LOZENGES_SUBJECT,
      data: {
        product: product,
        lozenges: lozenges,
        children: children,
        description: description
      }
    })));
  }, [lozenges, product, children, description]);
  return jsx(FadeIn, {
    css: fadeInStyles
  }, jsx(LinkItem, _extends({
    testId: "switcher-base-item",
    description: itemDescription,
    iconBefore: icon,
    iconAfter: elemAfter,
    target: getBooleanFF('platform.navigation.atlassian-switcher.design-refresh.m2.enabled') ? '_blank' : undefined,
    onClick: function onClick(event) {
      if (_onClick) {
        _onClick(event);
      }
    }
  }, rest), children, renderLozenges));
};
export default SwitcherItem;